import React, { FC, ReactElement, ReactNode } from 'react';
import UuidOverlay from '../UuidOverlay';

interface AppWithUuidProps {
  children: ReactNode;
}

const AppWithUuid: FC<AppWithUuidProps> = ({ children }): ReactElement => (
  <>
    {children}
    <UuidOverlay />
  </>
);

export default AppWithUuid;
